export default function hasShippingAddressCheck(shippingAddress = {}) {
  if (
    shippingAddress &&
    shippingAddress?.city &&
    shippingAddress?.postcode &&
    shippingAddress?.number
  ) {
    return true;
  }
  return false;
}
